import PrivacyNotice from './PrivacyNotice.vue';
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const el = document.getElementById("privacy-notice-app");
const gpcSignalDetected = el.getAttribute('gpc-signal-detected') === 'True';
const optedOutOfTrackingCookies = el.getAttribute('opted-out-of-tracking-cookies') === 'True';
const privacyControlsEnabled = el.getAttribute('privacy-controls-enabled') === 'True';

if (el) {
	new Vue({
		el,
		render: h => h(PrivacyNotice, {
			props: {
				privacyControlsEnabled,
				gpcSignalDetected,
				optedOutOfTrackingCookies
			}
		})
	});
}